import styled from '@emotion/styled'

import { breakpoints, container, spacing } from 'main/ui'

const horizontalGutter = spacing.majorScale(3)

export const Container = styled.div`
  overflow: hidden; /* clip shadow part of image, so we don't get a horizontal scrollbar */
  padding: ${spacing.majorScale(10 + 15)}px ${horizontalGutter}px ${spacing.majorScale(14)}px;

  @media (min-width: ${breakpoints.lg}px) {
    padding-bottom: ${spacing.majorScale(20)}px;
    padding-top: ${spacing.majorScale(7 + 16)}px;
  }
`

export const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: ${container.maxWidth.sm}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin: ${spacing.majorScale(12)}px auto 0;
    max-width: ${container.maxWidth.lg}px;
  }
`

export const Content = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    flex-direction: row;
  }
`

export const Benefit = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing.majorScale(4)}px;
`

export const BenefitIconContainer = styled.div`
  padding-right: ${spacing.majorScale(2)}px;
  padding-top: 3px;
`

export const ImageContainer = styled.div`
  flex: 0 0 ${spacing.majorScale(49)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: ${spacing.majorScale(8)}px;
  }
`

// Use margin so that the block size is just the image of the phone (with shadow overflowing),
// so that it's easier to position correctly
export const Image = styled.img`
  margin-left: -41.5%;
  margin-top: -19%;
  margin-bottom: -24%;
  width: 193%;
`
